import { Component, OnInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import { DataIoService } from '../../../services/data-io.service'
import { TranslationService } from '../../../services/translation.service';
@Component({
    selector: 'app-textinput',
    templateUrl: './textinput.component.html',
    styleUrls: ['./textinput.component.scss'],
    standalone: false
})
export class TextinputComponent implements OnInit {
	@Input()
	stringtype:string;

	@Input()
	text :string;
	
	@Output()
	onSave : EventEmitter<string> = new EventEmitter<string>();
	
	@Output()
	onTextChanged : EventEmitter<string> = new EventEmitter<string>();
	
	@Output()
	currentCharChanged : EventEmitter<string> = new EventEmitter<string>();
	characters : Array<string>;
	numbers = ["0","1","2","3","4","5","6","7","8","9"];
	alphabet = [
		"a",
		"b",
		"c",
		"d",
		"e",
		"f",
		"g",
		"h",
		"i",
		"j",
		"k",
		"l",
		"m",
		"n",
		"o",
		"p",
		"q",
		"r",
		"s",
		"t",
		"u",
		"v",
		"w",
		"x",
		"y",
		"z",
		"0",
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9"
	];
	currentText = '';
	currentChar = 'a';
	nextChar(){
		switch(this.currentChar){
			case 'delete':{
				this.currentChar = 'space';
				this.currentCharChanged.emit(' ');//{{{iconBlank}}}
				break;
			}
			case 'space':{
				if(this.stringtype == 'numberstring'){
					this.currentChar = '0';
				}else{
					this.currentChar = 'a';
				}
				
				this.currentCharChanged.emit(this.currentChar);
				break;
			}
			case 'save':{
				return;
			}
			default:{
				let char = this.currentChar.toLowerCase();
				let chars = this.ArrayToLower(this.characters);
				let idx = chars.indexOf(char);
				if(idx < chars.length -1){
					this.currentChar = this.characters[idx+1];
					this.currentCharChanged.emit(this.currentChar);
				}else{
					this.currentChar = 'save';
					this.currentCharChanged.emit('');
				}
				this.updatePosition();
				return;

			}

		}
	}


	previousChar(){
		switch(this.currentChar){
			case 'delete':{
				this.currentCharChanged.emit('');
				return;
			}
			case 'a':
			case 'A':{
				this.currentChar = 'space';
				this.currentCharChanged.emit(' ');//{{iconBlank}}
				return;
			}
			
			case 'space':{
				this.currentChar = 'delete';
				this.currentCharChanged.emit(' ');
				return;
			}
			case 'save':{
				this.currentChar = '9';
				return '9';
				this.currentCharChanged.emit('9');
			}
			default:{
				let char = this.currentChar.toLowerCase();
				let chars = this.ArrayToLower(this.characters);
				let idx = chars.indexOf(char);
				if(idx > 0){
					this.currentChar = this.characters[idx-1];
					this.currentCharChanged.emit(this.currentChar);
				}else{
					this.currentChar = 'space';
					this.currentCharChanged.emit('');
				}
				this.updatePosition();
				return;
			}
		}
	}



	elementWidth=1.19;
	elementWidthUnit="rem";
	alphabetOffset="0rem";
	updatePosition(){
		if(this.stringtype == 'numberstring'){

			return;
		}
		let offset=7;
		let idx = this.ArrayToUpper(this.characters).indexOf(this.currentChar.toUpperCase());
		if(idx == -1){
			idx = 0;
		}
		if(idx < offset){
			return;
		}
		if(idx > 29){
			return;
		}

		this.alphabetOffset=-1*(this.elementWidth*(idx-offset))+this.elementWidthUnit;
		//console.log("Alphabet-Offset: "+this.alphabetOffset)
	}	

    pans=0;
    panSkip=2;
	handleEvent(event){
		switch(event){
			case 'panup':{

                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }
			}
			case 'up':{
				this.nextChar();
				return;
			}
			case 'pandown':{

                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }
			}
			case 'down':{
				this.previousChar();
				return;
			}
			case 'confirm':{
				switch(this.currentChar){
					case 'space':{
						this.currentText+=" ";
						this.characters = this.ArrayToUpper(this.characters);
						break;
					}
					case 'delete':{
						this.currentText = this.currentText.substring(0,this.currentText.length-1);
						break;
					}
					case 'save':{
						//console.log("Emitting onSave("+this.currentText+")");
						this.onSave.emit(this.currentText);
						break;
					}
					default:{
						this.currentText += this.currentChar;
						let idx = this.characters.indexOf(this.currentChar);
						this.characters = this.ArrayToLower(this.characters);
						this.currentChar = this.characters[idx];
						this.onTextChanged.emit(this.currentText);
						break;
					}
				}
			}
		}
		//console.log("CurrentText: "+this.currentText);
	}
	constructor(private ioService: DataIoService, private translator: TranslationService) { 

	}
	tr(str:string):string{
		return this.translator.tr(str);
	}
	ArrayToLower(inputArray){
		let arr = inputArray.slice(0);
		for(let i=0;i<arr.length;i++){
			if(typeof arr[i] == "string"){
				arr[i]=arr[i].toLowerCase();
			}
		}
		return arr;
	}


	ArrayToUpper(inputArray){
		let arr = inputArray.slice(0);
		for(let i=0;i<arr.length;i++){
			if(typeof arr[i] == "string"){
				arr[i]=arr[i].toUpperCase();
			}
		}
		return arr;
	}
	subscription$:any;
	ngOnInit() {
		//console.log("StringType: "+this.stringtype);
		if(this.stringtype == 'numberstring'){
			this.characters = this.numbers;
			this.alphabetOffset="2.7"+this.elementWidthUnit;
			this.currentChar="0";
		}else{
			this.characters = this.alphabet;
		}
		//console.log("Initializing with text "+this.text);
		this.currentText = this.text;
		if(!this.currentText){
			this.currentText="";
			this.characters = this.ArrayToUpper(this.characters);
		}
		this.currentChar = "delete";

		this.onTextChanged.emit(this.currentText);

		this.subscription$ = this.ioService.inputs.events$.subscribe(
			(event)=>this.handleEvent(event)
			);
	}
	ngOnDestroy(){
		this.subscription$.unsubscribe();
	}	
}
